import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureLineModule, positionTextureLineModuleName } from '../modules/coast-position-texture';
import { VectorLineLayer } from './vector-line-layer';

// Animates vector line given by source position, speed and heading. RangeType decides if range is time in hours or distance in NM.
// Proper for relatively small position differences.
// Positions are taken directly from transformation buffer.
// Data must be this same like transformation data.

export class AnimatedVectorLineLayer<TData> extends VectorLineLayer<
    TData,
    { getId: Accessor<TData, number>; positionTexture: Texture | null }
> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureLineModule]
        };
    }

    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instanceSourcePositions']);
        manager.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureLineModuleName]: this.props
            });
        }
    }
}
